var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6798 7.25754L11.7892 3.96652C11.4381 3.35547 10.5576 3.35254 10.2025 3.96125L8.20754 7.38122C7.9433 7.8342 7.49773 8.15234 6.9835 8.25519L4.25759 8.80037C3.55159 8.94157 3.27649 9.80423 3.7704 10.3281L5.742 12.4192C6.16359 12.8663 6.3331 13.495 6.19346 14.0934L5.30105 17.918C5.11761 18.7042 5.96653 19.3265 6.66106 18.9149L10.0658 16.8973C10.6421 16.5558 11.3587 16.5558 11.935 16.8973L15.3397 18.9149C16.0343 19.3265 16.8832 18.7042 16.6997 17.918L15.7995 14.06C15.6642 13.48 15.819 12.8705 16.2146 12.4254L18.1887 10.2046C18.659 9.67546 18.3775 8.83557 17.6833 8.69672L14.9099 8.14204C14.3915 8.03836 13.9431 7.71595 13.6798 7.25754Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon);
export default __webpack_public_path__ + "static/media/integrationsIcon.eb675a241b0b162f2c601250343c9b36.svg";
export { ForwardRef as ReactComponent };